import axiosClient from "./axiosClient";
import ROUTES from "./api_routes";

async function registerNgo(ngoData, userData, logoFile, coverFile, galleryFiles = []) {
  const formData = new FormData();
  
  formData.append('ngo_registration_request[ngo]', JSON.stringify(ngoData));
  formData.append('ngo_registration_request[user]', JSON.stringify({
    ...userData,
    password: userData.password
  }));
  
  if (logoFile) {
    formData.append('ngo_registration_request[logo]', logoFile);
  }
  
  if (coverFile) {
    formData.append('ngo_registration_request[cover_image]', coverFile);
  }

  // Galeria de imagens
  if (galleryFiles && galleryFiles.length > 0) {
    galleryFiles.forEach((file, index) => {
      formData.append(`ngo_registration_request[gallery_images][]`, file);
    });
  }

  return axiosClient.post(ROUTES.POST_NGO_REGISTRATION_REQUEST, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

async function updateNgo(ngoData, logoFile, coverFile, galleryFiles = []) {
  const formData = new FormData();
  
  formData.append('ngo_registration_request[ngo]', JSON.stringify(ngoData));
  
  if (logoFile) {
    formData.append('ngo_registration_request[logo]', logoFile);
  }
  
  if (coverFile) {
    formData.append('ngo_registration_request[cover_image]', coverFile);
  }

  // Galeria de imagens
  if (galleryFiles && galleryFiles.length > 0) {
    galleryFiles.forEach((file, index) => {
      formData.append(`ngo_registration_request[gallery_images][]`, file);
    });
  }

  return axiosClient.put(ROUTES.PUT_NGO_REGISTRATION, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

async function getRegistrationStatus() {
  return axiosClient.get(ROUTES.GET_NGO_REGISTRATION_STATUS);
}

export default {
  registerNgo,
  updateNgo,
  getRegistrationStatus
}; 